export const jost = {
  name: 'Jost',
  fallback: 'sans-serif',
  weight: [300, 400, 700]
};

export const arialHelvetica = {
  name: 'Arial, Helvetica',
  fallback: 'sans-serif',
  weight: [300, 400, 700]
};

export const openSans = {
  name: 'Open Sans',
  fallback: 'sans-serif',
  weight: [300, 400, 700],
};

export const lato = {
  name: 'Lato',
  fallback: 'sans-serif',
  weight: [300, 400, 700]
};

export const montserrat = {
  name: 'Montserrat',
  fallback: 'sans-serif',
  weight: [300, 400, 700],
};
export const lobster = {
  name: 'Lobster',
  fallback: 'sans-serif',
  weight: [400],
};

export const raleway = {
  name: 'Raleway',
  fallback: 'sans-serif',
  weight: [300, 400, 700]
};

export const ibmPlexSans = {
  name: 'IBM Plex Sans',
  fallback: 'sans-serif',
  weight: [300, 400, 700]
};

export const notoSans = {
  name: 'Noto Sans',
  fallback: 'sans-serif',
  weight: [300, 400, 700]
};

export const oldStandardTT = {
  name: 'Old Standard TT',
  fallback: 'serif',
  weight: [400, 700]
};

export const mulish = {
  name: 'Mulish',
  fallback: 'sans-serif',
  weight: [300, 400, 700]
};

export const poppins = {
  name: 'Poppins',
  fallback: 'sans-serif',
  weight: [200, 400, 600]
};
export const sarabun = {
  name: 'Sarabun',
  fallback: 'sans-serif',
  weight: [100, 400, 600]
};

export const fontsList = [
  jost,
  arialHelvetica,
  openSans,
  lato,
  montserrat,
  raleway,
  ibmPlexSans,
  notoSans,
  oldStandardTT,
  mulish,
  lobster,
  poppins,
  sarabun
];

export default fontsList;
